import React from 'react';
import PropTypes from 'prop-types';

export default function CardIcon({ size, color, ...rest }) {
  return (
    <svg width={size} height={size} viewBox="0 0 8 11" {...rest}>
      <rect
        width="8"
        height="9.6"
        x="304.3"
        y="-.3"
        fill={color}
        fillRule="evenodd"
        transform="translate(-304.3 .8)"
      />
    </svg>
  );
}

CardIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
};

CardIcon.defaultProps = {
  size: 15,
  color: '#000',
};
